import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DIALOG_DATA } from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { DeviceInfoService } from '../../services/device-info.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { ToasterService } from '../../services/toaster.service';
import { ConfigureScanMenuComponent } from '../configure-scan-menu/configure-scan-menu.component';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { ScanQrNfcComponent } from '../scan-qr-nfc/scan-qr-nfc.component';
import { CapacitorNfc } from '@capgo/capacitor-nfc';
import { Capacitor, registerPlugin } from '@capacitor/core';
import {
  AndroidSettings,
  IOSSettings,
  NativeSettings,
} from 'capacitor-native-settings';

const HardwareCheck = registerPlugin<{
  checkNfcHardware(): Promise<{ hasHardware: boolean; isEnabled: boolean }>;
}>('HardwareCheck');

@Component({
  selector: 'gtapp-scan-checkpoint',
  standalone: false,
  templateUrl: './scan-checkpoint.component.html',
  styleUrl: './scan-checkpoint.component.scss',
})
export class ScanCheckpointComponent implements OnInit {
  @ViewChild('nfcPermissionTempateRef') nfcPermissionTempateRef: any;

  showNormalScanBtn: boolean = true;
  showQRScanBtn: boolean = true;
  showNFCScanBtn: boolean = false;

  cameraOnDevice: boolean = true;

  nfcStateStatus: string = '';

  isNativeApp = Capacitor.isNativePlatform();

  constructor(
    @Optional() @Inject(DIALOG_DATA) public dialogData: any,
    @Optional() protected dialogRef: DialogRef,
    private dialogService: ModalDialogueService,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
    private deviceInfoService: DeviceInfoService,
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
  ) {}

  async checkPermissions(): Promise<number> {
    return new Promise(async (resolve) => {
      // this.cameraOnDevice = await this.hasCamera();
      this.showNormalScanBtn =
        this.dialogData?.showNormalScanBtn == false ? false : true;
      this.showQRScanBtn =
        this.dialogData?.showQRScanBtn == false ? false : true;
      this.showNFCScanBtn =
        this.dialogData?.showNFCScanBtn == false ? false : true;

      this.showNFCScanBtn = await this.nativeNfcSupport();

      let userData = this.appService.getUserData();
      const scanMenuConfig = userData?.preferences?.scan_menu_config || {};

      if (Object.keys(scanMenuConfig)?.length) {
        this.showNormalScanBtn =
          scanMenuConfig?.scan_gps && this.showNormalScanBtn;
        this.showQRScanBtn = scanMenuConfig?.scan_qr && this.showQRScanBtn;
        this.showNFCScanBtn = scanMenuConfig?.scan_nfc && this.showNFCScanBtn;
      }
      resolve(
        +this.showNormalScanBtn + +this.showQRScanBtn + +this.showNFCScanBtn,
      );
    });
  }
  async nativeNfcSupport() {
    if (this.isNativeApp) {
      if (Capacitor.getPlatform() == 'android') {
        try {
          const hardwareStatus = await HardwareCheck.checkNfcHardware();
          if (!hardwareStatus.isEnabled) this.nfcStateStatus = 'denied';
          return hardwareStatus.hasHardware;
        } catch (e) {
          return false;
        }
      } else {
        const isNFCSupported = await CapacitorNfc.isSupported();
        return isNFCSupported.supported;
      }
    } else {
      const isChrome = await this.deviceInfoService.isDeviceChrome();
      return 'NDEFReader' in window && isChrome;
    }
  }
  async ngOnInit() {
    const trueCount = await this.checkPermissions();

    if (trueCount >= 1) {
      // no need to do anything show the dialog box with the options
      // } else if (trueCount == 1) {
      //   // skip showing the dialogbox
      //   if (this.showNormalScanBtn) {
      //     this.onCloseDialog({ source: 'scanCheckPoint' });
      //   } else if (this.showQRScanBtn) {
      //     this.openQRCode();
      //   } else if (this.showNFCScanBtn) {
      //     this.readNFC();
      //   }
    } else {
      this.configureCheckpointScanMenu();
    }
  }
  hasCamera(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        resolve(false);
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          const videoInputDevices = devices.filter(
            (device) => device.kind === 'videoinput',
          );
          resolve(videoInputDevices.length > 0);
        })
        .catch((err) => {
          resolve(false);
          throw err;
        });
    });
  }
  async readNFC() {
    if (this.isNativeApp) {
      this.openNFCReader();
      return;
    }
    try {
      const status = await navigator.permissions.query({
        name: 'nfc' as PermissionName,
      });
      if (status.state === 'granted') {
        this.openNFCReader();
      } else if (status.state === 'prompt') {
        this.nfcStateStatus = 'prompt';
        const dialogRef = this.dialogService.open(
          this.nfcPermissionTempateRef,
          {},
          this.viewContainerRef,
        );
        const value = await firstValueFrom(dialogRef.afterClosed());
        if (value === true) {
          this.openNFCReader();
        }
      } else {
        this.nfcStateStatus = 'denied';
        this.dialogService.open(
          this.nfcPermissionTempateRef,
          {},
          this.viewContainerRef,
        );
      }
    } catch (error) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Error checking NFC permission',
      });
      throw error;
    }
  }
  async checkNfcPermission() {
    let timeOutCheck: any;
    try {
      this.spinnerService.show();

      const ndef = new NDEFReader();
      timeOutCheck = setTimeout(() => {
        this.nfcStateStatus = 'restricted';
        this.spinnerService.hide();
      }, 5000);
      await ndef.scan();

      this.dialogRef?.close();
      if (timeOutCheck) clearTimeout(timeOutCheck);
      this.spinnerService.hide();
      this.openNFCReader();
    } catch (error: any) {
      this.spinnerService.hide();
      if (timeOutCheck) clearTimeout(timeOutCheck);
      if (error.name === 'NotAllowedError') {
        this.nfcStateStatus = 'denied';
      } else if (error?.message) {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: error?.message,
        });
      }

      throw error;
    }
  }

  onCloseDialog(value: any = false) {
    this.dialogRef.close(value);
  }
  async checkCameraPermissionDenied() {
    try {
      if (!navigator.permissions) {
        // Permissions API not supported
        return false;
      }

      const permission = await navigator.permissions.query({
        name: 'camera' as PermissionName,
      });
      const isIOS = this.deviceInfoService.isPhoneIOS();

      return Boolean(
        !['granted', 'prompt'].includes(permission.state) && !isIOS,
      );
    } catch (error) {
      return false;
    }
  }

  async openNFCReader() {
    const enabled = await CapacitorNfc.getStatus();

    if (enabled.status == 'NFC_DISABLED') {
      this.nfcStateStatus = 'denied';
      this.dialogService.open(
        this.nfcPermissionTempateRef,
        {},
        this.viewContainerRef,
      );

      return;
    }
    const dialogRef = this.dialogService.open(ScanQrNfcComponent, {
      data: {
        nfcReader: true,
        patrolRouteId: this.dialogData?.patrolRouteId || '',
        jobId: this.dialogData?.jobId || '',
      },
    });
    const res = await firstValueFrom(dialogRef?.afterClosed());
    this.onCloseDialog({ source: 'scanNFCCode', data: res });
  }
  async openSettings() {
    await NativeSettings.open({
      optionAndroid: AndroidSettings.NfcSettings,
      optionIOS: IOSSettings.App,
    });
  }
  async configureCheckpointScanMenu() {
    const dialogRef = this.dialogService.open(ConfigureScanMenuComponent);
    const ref = await firstValueFrom(dialogRef?.afterClosed());
    const trueCount = await this.checkPermissions();

    if (trueCount == 0) this.onCloseDialog(false);
  }

  async openQRCode() {
    if (!this.cameraOnDevice) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Unable to access camera',
      });
      return;
    }
    if (await this.checkCameraPermissionDenied()) {
      this.deviceInfoService.deviceInfoSubject.next({
        permissionStatus: 'cameraDisabled',
      });
      return;
    }

    const dialogRef = this.dialogService.open(ScanQrNfcComponent, {
      data: {
        patrolRouteId: this.dialogData?.patrolRouteId || '',
        jobId: this.dialogData?.jobId || '',
      },
    });
    const res = await firstValueFrom(dialogRef?.afterClosed());

    this.onCloseDialog({ source: 'scanQrCode', data: res });
  }
}
